import { WorkspaceManagement } from "@/components/WorkspaceManagement";
import { useNavigate } from "react-router-dom";

export const WorkspacesPage = () => {
  const navigate = useNavigate();
  const handleBack = () => navigate("/");
  return <WorkspaceManagement onBack={handleBack} />;
};
